const ApiMethods = ["blur", "focus", "click", "select", "setRangeText", "setSelectionRange", "checkValidity", "reportValidity", "setCustomValidity"];
export function useForwardInputApi(inputRef) {
  return targetRef => {
    const element = targetRef.current;
    ApiMethods.forEach(x => {
      element[x] = (...args) => {
        // We know the args passed here will match the one needed.
        // @ts-ignore
        inputRef.current[x](...args);
      };
    });
    return element;
  };
}